import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { APIResponse } from '../_types/api-responses.types';
import {
  GetCategoriesRequest,
  GetCategoriesResponse,
} from '../_types/product.types';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  _headers: HttpHeaders;

  _baseURL: any;

  user: any;

  deviceId: number;

  deviceInfo: any;

  constructor(
    private httpClient: HttpClient,
    private globaols: Globals,
    private deviceService: DeviceDetectorService
  ) {
    this.deviceId = Date.now();
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.user = this.globaols.getUser();
    this._headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('content-type', 'application/json')
      .set('partner-id', this.user.partnerId);
    this._baseURL = environment.apiUrl;
  }

  get headers() {
    return this._headers.set('Access-Token', this.globaols.getUser().token);
  }

  _addCategory(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/category/add`,
      obj,
      { headers: this.headers }
    );
  }

  _updateCategory(obj: any): Observable<any> {
    return this.httpClient.put(
      `${this._baseURL}api/catalogue/v1/category/update`,
      obj,
      { headers: this.headers }
    );
  }

  _getCategoryById(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/category/get`,
      obj,
      { headers: this.headers }
    );
  }

  _listAllCategory(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/category/get/all`,
      obj,
      { headers: this.headers }
    );
  }

  _deleteCategory(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/category/delete`,
      obj,
      { headers: this.headers }
    );
  }

  _getAllSubcategory(obj: any): Observable<any> {
    return this.httpClient.post(
      `${this._baseURL}api/catalogue/v1/category/get/subcategories`,
      obj,
      { headers: this.headers }
    );
  }

  getPartnerCategories(
    obj: GetCategoriesRequest
  ): Observable<APIResponse<GetCategoriesResponse>> {
    return this.httpClient.post<APIResponse<GetCategoriesResponse>>(
      `${this._baseURL}api/catalogue/v1/category/get/all/partner`,
      obj,
      { headers: this.headers }
    );
  }

  getAgentCategories(
    obj: GetCategoriesRequest
  ): Observable<APIResponse<GetCategoriesResponse>> {
    return this.httpClient.post<APIResponse<GetCategoriesResponse>>(
      `${this._baseURL}api/catalogue/v1/category/get/all/agent`,
      obj,
      { headers: this.headers }
    );
  }
}
